import type { RawSlug, Slug } from "@/modules/jobSearchPrefiltered/types"

export type LocalizedContent = {
  title: `${"job_search_prefiltered.content"}${string}`
  subtitle: `${"job_search_prefiltered.content"}${string}`
  shortDescription: `${"job_search_prefiltered.content"}${string}`
  description: `${"job_search_prefiltered.content"}${string}`
  metaTitle: `${"job_search_prefiltered.content"}${string}`
  metaDescription: `${"job_search_prefiltered.content"}${string}`
}

export const getLocalizedContentKeysForSlug = (slug: Slug | RawSlug): LocalizedContent => {
  const keyPrefix: `${"job_search_prefiltered.content"}${string}` = `job_search_prefiltered.content`
  let slugKeyPrefix: `${"job_search_prefiltered.content"}${string}` = `${keyPrefix}.contract_city`

  if (slug.params.function) {
    slugKeyPrefix = `${keyPrefix}.contract_city_function`
  } else if (slug.params.industry) {
    slugKeyPrefix = `${keyPrefix}.contract_city_industry`
  }

  return {
    description: `${slugKeyPrefix}.description`,
    metaDescription: `${slugKeyPrefix}.metaDescription`,
    metaTitle: `${slugKeyPrefix}.metaTitle`,
    shortDescription: `${slugKeyPrefix}.shortDescription`,
    subtitle: `${slugKeyPrefix}.subtitle`,
    title: `${slugKeyPrefix}.title`,
  }
}
